<template>
	<div class="desktop" :style="{ height: height }">
		<!-- <div class="statusbar">
      <i class="el-icon-s-home"></i>我的桌面
    </div> -->

		<div class="welcome">
			<span>欢迎您：{{ u_name }}</span>
			<span class="vips">会员卡：{{ vipaccount }}</span>
		</div>

		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>数据统计</span>
				<!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
			</div>
			<div class="panel">
				<el-row :gutter="20">
					<el-col :span="4">
						<div class="grid-content bg-purple">
							<div class="title">可用余额：{{ ye }}</div>
							<div class="flexBox card-content">
								<div>
									<div>余额：{{ vacancy }}</div>
									<div class="ed">信用额度：{{ quota }}</div>
								</div>
								<div><el-button type="primary" @click="vipcharge" size="mini">充值</el-button></div>
							</div>
						</div>
					</el-col>
					<el-col :span="4">
						<!-- <div class="grid-content bg-purple">
							<div class="title">商品库存总数</div>
							<div class="flexBox card-content">
								<div>1000</div>
								<el-button type="primary" size="mini">购买</el-button>
							</div>
						</div> -->
					</el-col>
					<el-col :span="4">
						<!-- <div class="grid-content bg-purple">
							<div class="title">待处理工单</div>
							<div class="card-content">10</div>
						</div> -->
					</el-col>
					<el-col :span="4">
						<!-- <div class="grid-content bg-purple">
							<div class="title">上门取件</div>
							<div class="card-content">100</div>
						</div> -->
					</el-col>
					<el-col :span="4">
						<!-- <div class="grid-content bg-purple">
							<div class="title">问题订单</div>
							<div class="card-content">50</div>
						</div> -->
					</el-col>
					<el-col :span="4">
						<!-- <div class="grid-content bg-purple">
							<div class="title">商品库存总数</div>
							<div class="card-content">1000</div>
						</div> -->
					</el-col>
				</el-row>
			</div>
		</el-card>
		<el-row :gutter="20">
			<el-col :span="6">
				<!-- <div class="grid-content bg-purple">
					<el-card class="box-card">
						<div slot="header" class="clearfix"><span class="listtit">订单统计</span></div>
						<div class="panel"><v-chart :options="option" autoresize theme="light"></v-chart></div>
						<div class="more"><span class="morego">更多>></span></div>
					</el-card>
				</div> -->
			</el-col>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<el-card class="box-card pop">
						<div slot="header" class="clearfix"><span class="listtit">会员卡充值明细</span></div>
						<div class="panel">
							<el-table empty-text="暂无数据" :data="vipbill_charge" style="width: 100%" size="mini">
								<el-table-column prop="amount" label="金额"></el-table-column>
								<el-table-column prop="createtime" label="操作时间"></el-table-column>
								<el-table-column prop="p_paytype" label="操作方式"></el-table-column>	</el-table>
						</div>
						<div class="mores"><span class="moresgo" @click="govipbill('充值明细')">更多>></span></div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<el-card class="box-card pop">
						<div slot="header" class="clearfix"><span class="listtit">会员卡扣费明细</span></div>
						<div class="panel">
							<div class="panel">
								<el-table empty-text="暂无数据" :data="vipbill_pay" style="width: 100%" size="mini">
									<el-table-column prop="amount" label="金额"></el-table-column>
									<el-table-column prop="createtime" label="操作时间"></el-table-column>
									<el-table-column prop="p_paytype" label="操作方式"></el-table-column>
								</el-table>
							</div>
						</div>
						<div class="mores"><span class="moresgo" @click="govipbill('扣费明细')">更多>></span></div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="6">
				<!-- <div class="grid-content bg-purple">
					<el-card class="box-card pop">
						<div slot="header" class="clearfix"><span class="listtit">最新消息</span></div>
						<div class="panel">
							<ul>
								<li v-for="(item, index) in news" :key="index">
									<i class="el-icon-message-solid"></i>
									{{ item.title }}
								</li>
							</ul>
						</div>
						<div class="mores"><span class="moresgo">更多>></span></div>
					</el-card>
				</div> -->
			</el-col>
		</el-row>
		<div></div>
		<!-- <el-card class="box-card">
			<div slot="header" class="clearfix"><span>广告位</span></div>
			<div class="panel"></div>
		</el-card> -->
		
		<selectpaytype ref="selectpaytype"></selectpaytype>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import selectpaytype from '@/components/cw/selectpaytype.vue';
export default {
	components: {selectpaytype},
	props: {},
	data() {
		return {
			height: (window.innerHeight * 85) / 100 + 'px',
			u_name: '',
			vipaccount: '',
			ye: 0.0,
			vacancy: 0.0,
			quota: 0.0,
			// chargefrom: 'CNY',
			// chargerate: 0,
			// chargeamount: 0,
			// chargefromamount: 1,
			// amount: 0,
			// handlefee: 0,
			// showchargewin: false,
			// chargedisabled: true,
			option: {
				series: [
					{
						name: '访问来源',
						type: 'pie',
						radius: '45%',
						center: ['30%', '30%'],
						data: [
							{
								state: 'wsh',
								value: 100,
								name: '未审核'
							},
							{
								state: 'sh',
								value: 2300,
								name: '未申报'
							},
							{
								state: 'dy',
								value: 5960,
								name: '已申报'
							},
							{
								state: 'fx',
								value: 1000,
								name: '已放行'
							},
							{
								state: 'lz',
								value: 300,
								name: '流转中'
							},
							{
								state: 'qs',
								value: 6000,
								name: '已签收'
							},
							{
								state: 'hs',
								value: 100,
								name: '问题件'
							}
						],
						columns: [
							{
								field: 'remark',
								title: '交易描述'
							},
							{
								field: 'amount',
								title: '金额'
							},
							{
								field: 'u_createtime',
								title: '交易时间'
							}
						],
						columns2: [
							{
								field: 'remark',
								title: '操作描述'
							},
							{
								field: 'amount',
								title: '个数'
							},
							{
								field: 'u_createtime',
								title: '操作时间'
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			},
			news: [
				{
					title: '最近一个月成交量突破100万单'
				},
				{
					title: '海关清关税率最新调整表'
				},
				{
					title: '疫情导致海外航班不定期'
				}
			],
			vipbill_pay:[],
			vipbill_charge:[],
			options: {
				color: ['#64CDF0', '#F5686F']
			},
			options: {
				xAxis: [
					{
						type: 'category',
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
						// 修改文本的颜色
						axisLabel: {
							color: '#BB3137',
							fontSize: 10
						},
						// 修改轴线的颜色
						axisLine: {
							lineStyle: {
								color: '#BB3137'
							}
						}
					}
				]
			},
			isload:{
				vipbill:false
			}
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/desktop.scss');
		});
	},
	methods: {
		init() {
			this.vipaccount = localStorage.getItem('vipaccount');
			if(!this.isload.vipbill){
				this.loadvipbill('充值记录');
				this.loadvipbill('扣费记录');
			}
			this.getvipaccount();
			this.u_name=localStorage.getItem('u_name');
		},
		//获取会员卡基本信息
		getvipaccount() {
			var that = this;
			if (this.vipaccount != '') {
				this.$apipost.get.getvipbyvipaccount({ vipaccount: this.vipaccount }).then(res => {
					if (res.vacancy != '') that.vacancy = res.vacancy;
					if (res.ye != '') that.ye = res.ye;
					if (res.quota != '') that.quota = res.quota;
				});
			}
		},
		vipcharge(){
			if(this.$refs.selectpaytype!=undefined){
				this.$refs.selectpaytype.init({description:'会员充值'});
			}
		},
		//跳转到会员卡明细界面
		govipbill(type){
			Utils.$emit('go', { l_url: '/cw/vipbill',l_id:98, l_name: '会员卡明细', urlparam: {vipaccount:this.vipaccount,type:type} });
		},
		//加载会员卡明细
		loadvipbill(type){
			var that=this;
			var paraminfo = {
				search:'',
				pageindex:0,
				pagesize:6,
				sort:'',
				showcol:'',
				tab:type,
				userid: localStorage.getItem('userid'),
				mode:'会员卡明细',
				vipaccount: localStorage.getItem('vipaccount')
			};
			
			this.$apipost.get
				.VipBill({
					paraminfo: paraminfo
				})
				.then(res => {
					that.isload.vipbill=true;
					if (res.data.length > 0) {
						if(type=='充值记录')
							that.vipbill_charge=res.data;
						else
							that.vipbill_pay=res.data;
					}
				}).catch(e=>{
					that.loadvipbill(type);
			});		
		},
		//为了解析地址能异步持续调用，故将此方法写到桌面页面中来，因为桌面页面不会关闭，不会影响
		ThreadResolve(p_batch,batch){
			if(p_batch==undefined)
				p_batch='';
			if(batch==undefined)
				batch='';	
				
			this.$apipost.post.ThreadResolve_cg({ p_batch:p_batch,batch:batch }).then(res => {});
			this.$apipost.post.ThreadResolve({ p_batch: p_batch,batch:batch}).then(res => {});
		}
	}
};
</script>
